import React from 'react';
import { statusColorClass } from '../lib/openPlatformFormatters';

const IntegrationStatusBadge = ({ status }) => (
  <span className={`inline-flex items-center rounded border px-2 py-0.5 text-[11px] font-semibold ${statusColorClass(status)}`}>
    {String(status || '-').toUpperCase()}
  </span>
);

export default IntegrationStatusBadge;
